import axios from 'axios';
import { serialize } from 'object-to-formdata';

import { transformIncomingData, transformOutgoingData } from './dataTransform';
import { ApiResponse, transformError, transformSuccess } from './responseTransform';

export const axiosClient = axios.create({
  baseURL: `https://${window.env?.ALERTS_BASE_DOMAIN}`,
  headers: {
    'Referrer-Policy': 'strict-origin-when-cross-origin',
  },
  withCredentials: true,
});

axiosClient.interceptors.request.use((req) => {
  req.headers.Accept = 'application/json';

  return req;
});

axiosClient.interceptors.request.use((req) => {
  req.params = transformOutgoingData(req.params);

  return req;
});

axiosClient.interceptors.request.use((req) => {
  if (req.data) {
    req.data = transformOutgoingData(req.data);
  }

  return req;
});

axiosClient.interceptors.response.use((resp) => {
  if (resp.data) {
    resp.data = transformIncomingData(resp.data);
  }

  return resp;
});

export const getRequest = <T>(URL): Promise<ApiResponse<T>> =>
  axiosClient
    .get<T>(`/${URL}`)
    .then((response) => transformSuccess<T>(response))
    .catch((error) => transformError(error));
export const getWithParamsRequest = <T>(URL, queryParams, signal?): Promise<ApiResponse<T>> =>
  axiosClient
    .get<T>(`/${URL}`, { params: queryParams, signal: signal })
    .then((response) => transformSuccess<T>(response))
    .catch((error) => transformError(error));
export const postRequest = <T>(URL, payload): Promise<ApiResponse<T>> =>
  axiosClient
    .post(`/${URL}`, payload)
    .then((response) => transformSuccess<T>(response))
    .catch((error) => transformError(error));
export const postRequestWithFormData = <T>(URL, payload): Promise<ApiResponse<T>> =>
  axiosClient
    .post(`/${URL}`, serialize(transformOutgoingData(payload)))
    .then((response) => transformSuccess<T>(response))
    .catch((error) => transformError(error));
export const putRequest = <T>(URL, payload) => axiosClient.put<T>(`/${URL}`, payload).then((response) => response);
export const putRequestWithFormData = <T>(URL, payload) =>
  axiosClient.put<T>(`/${URL}`, serialize(transformOutgoingData(payload))).then((response) => response);
export const deleteRequest = <T>(URL) => axiosClient.delete<T>(`/${URL}`).then((response) => response);
